import React, { useEffect, useState, useRef } from 'react';
import * as echarts from 'echarts';
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';

const toFixed0 = (value, point = 2) => {
  let _newVal: string | number = parseFloat(value);
  if (value == '' || isNaN(_newVal)) {
    return '-';
  }
  _newVal = _newVal.toFixed(point);
  return _newVal + '%';
};

const GameList = ['mobile', 'pc', 'console'];
const GAME_TYPE: { [key: string]: any } = {
  mobile: 'Mobile',
  pc: 'PC',
  console: 'Console',
};

export default function EchartLine(props: any) {
  const {
    SummaryList,
    tooltipFormatter,
    list,
    getSelectedLegend,
    windowHeight = 958,
    windowWidth = 1366,
  } = props;

  let isWindowMaxHight = document.body.clientHeight > windowHeight;
  let isWindowMaxWidth = document.body.clientWidth > windowWidth;

  const refDom = useRef(null);
  const [option, setOption] = useState<{ [key: string]: any }>({});
  const [selected, setSelected] = useState(false);
  let myChart;

  const initOption = () => {
    if (!list?.length) return;
    let _option = {
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        extraCssText: 'border: none;',
        padding: 0,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: {
            show: true,
            color: '#3B3D4B',
            backgroundColor: '#FFF',
          },
        },
        formatter: selected ? '' : tooltipFormatter,
        appendToBody: true,
      },
      legend: {
        show: true,
        // top: 'bottom',
        icon: 'circle',
        type: 'scroll',
        selectedMode: true,
        textStyle: {
          //样式
          fontSize: 12,
          color: '#888',
        },
        pageIconSize: 10,
        pageTextStyle: {
          color: '#707070', //翻页数字颜色
        }, //翻页数字设置
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 20,
        formatter: (name) => {
          if (GameList?.includes(name)) {
            return GAME_TYPE[name];
          }
          return name;
        },
        bottom: -1,
      },
      grid: {
        left: 2,
        right: '0',
        bottom: 20,
        top: 15,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: SummaryList.date,
        axisTick: {
          alignWithLabel: true,
        },
        axisLabel: {
          margin: isWindowMaxWidth && isWindowMaxHight ? 10 : 8,
          interval: 0,
          showMaxLabel: true,
          showMinLabel: true,
          color: '#000',
          opacity: 0.45,
          formatter: function (value) {
            return value;
          },
        },
        axisLine: {
          show: true,
          onZero: false, //当y轴有负数时,让x轴下落在y轴最小值
          lineStyle: {
            color: '#BFBFBF',
            //透明度会展示到虚线，暂时用纯色代替
            // color: '#000',
            // opacity: 0.25,
            width: 1,
          },
        },
      },
      yAxis: [
        {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
          splitNumber: 3,
          axisLabel: {
            color: '#000',
            opacity: 0.45,
            formatter: (value) =>
              selected ? null : `${mathFormat(value, true)}`,
          },
        },
        {
          type: 'value',
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: (value) => {
              return selected
                ? null
                : `${value === 0 ? value : toFixed0(value * 100, 0)}`;
            },
          },
          splitNumber: 3,
        },
      ],
      color: SummaryList.color,
      series: [...list],
    };
    setOption(_option);
  };

  const handleResize = () => {
    try {
      myChart.resize();
    } catch (err) {}
  };

  useEffect(() => {
    initOption();
  }, [list, SummaryList, selected]);

  useEffect(() => {
    myChart = echarts.init(refDom!.current!, null, { devicePixelRatio: 2.5 });
    option && myChart.setOption(option);
  }, [option]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    if (myChart) {
      try {
        myChart.on('legendselectchanged', (params: any) => {
          getSelectedLegend && getSelectedLegend(params);
          if (params?.selected) {
            const result = Object.values(params?.selected).every(
              (item) => !item,
            );
            setSelected(result);
          }
        });
      } catch (err) {}
    }
    return () => {
      if (myChart) {
        try {
          myChart.off('legendselectchanged');
        } catch (err) {}
      }
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      className="eacherLine"
      ref={refDom}
      style={{ height: 240, width: '100%' }}
    />
  );
}
